<template>
  <div>
    <div class="name">
      <vs-input
        :placeholder="$t('dash.pages.group_placeholder')"
        v-model="form.name"
      />
    </div>
    <div class="pages-available">
      <div class="title">
        {{ $t('dash.pages.group.available_pages') }}
        <span @click="showAllPages = !showAllPages">
          {{ !showAllPages ? $t('dash.pages.group.all_pages') : $t('dash.pages.groups.without') }}
        </span>
      </div>
      <div class="content">
        <div class="search-page">
          <vs-input
            v-model="pageFilter"
            :class="{'input': true}"
            color="#B20564"
            class="inputx"
            icon-after="true"  icon="search"
            :placeholder="$t('dash.settings.user.label.page_filter')"
          />
        </div>
        <ul>
          <li class="page" v-for="item in pages" :key="item.id"
                :class="[{'hide': !checkPageFilter(item) || checkPagesInGroups(item), 'select': selectedToAdd.find(p => p.id == item.id) }]" @click="selectAvailable(item)">
            <div class="page-wrapper">
              <div class="page-content">
                <Tooltip :text="item.name" position="top">
                  <page-image-avatar :page="item"/>
                  <p class="page-name">{{ item.name }}</p>
                  &nbsp;
                </Tooltip>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </div>

    <div class="actions">
      <div class="all" @click="all">
        <img src="../../../assets/img/icon-RAZ.svg" alt="icon RAZ">
      </div>
      <div class="add" @click="add">
        <img src="../../../assets/img/icon-right-arrow.svg" alt="icon right arrow">
      </div>
      <div class="remove" @click="remove">
        <img src="../../../assets/img/icon-left-arrow.svg" alt="icon left arrow">
      </div>
      <div class="raz" @click="raz">
        <img src="../../../assets/img/icon-RAZ.svg" alt="icon RAZ">
      </div>
    </div>

    <div class="pages-affected">
      <div class="title">{{ $t('dash.pages.group.in_group') }}</div>
      <div class="content">
        <ul>
          <li class="page" v-for="(item, index) in form.pages" :key="item.id"
                :class="[{'select': selectedToRemove.find(p => p.id == item.id) }]" @click="selectAffected(item)">
            <div class="page-wrapper">
              <div class="page-content">
                <Tooltip :text="item.name" position="top">
                  <page-image-avatar :page="item"/>
                  <p class="page-name">{{ item.name }}</p>
                  &nbsp;
                </Tooltip>
              </div>
              <div class="position">
                <div class="top" :class="[{'disable': index == 0}]" @click="changePosition(index, index-1)">
                  <img alt="top" class="hide-group" src="../../../assets/img/icon-hide-group.svg"/>
                </div>
                <div class="bottom" :class="[{'disable': index == form.pages.length-1}]" @click="changePosition(index, index+1)">
                  <img alt="bottom" class="hide-group" src="../../../assets/img/icon-hide-group.svg"/>
                </div>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </div>

    <div class="submit">
      <vs-button 
          v-if="group.id"
          class="delete"
          @click="erase()"
          color="#6a1f4c">
          <p>{{ $t('dash.pages.group.remove') }}</p>
        </vs-button> 
       <vs-button 
          class="validate"
          @click="submit"
          color="#6a1f4c">
          <p>{{ $t('dash.pages.overlay.validate') }}</p>
        </vs-button> 
    </div>

  </div>
</template>

<script>

import PageImageAvatar from '../PageImageAvatar.vue'
import Groups from '../../mixins/Groups'
import Tooltip from './../tooltip/tooltipInit.vue'

export default {
  name: 'component-groups',

  mixins: [Groups],

  components: {
    PageImageAvatar,
    Tooltip
  },

  props: {
    group: Object,
    pages: Array,
    allPages: Array,
    groups: Array
  },

  data() {
    return {
      form: {
        name: null,
        pages: []
      },
      pageFilter: '',
      selectedToAdd: [],
      selectedToRemove: [],
      showAllPages: false
    }
  },

  computed: {
    listPages() {
      return this.pages.filter(p => !this.form.pages.includes(p.id)) || []
    }
  },

  mounted() {
    if(this.group && this.group.id) {
      this.form.name = this.group.name
      this.form.pages = this.group.pages.map(pid => this.pages.find(p => p.id == pid)).filter(p => p)
    }
  },

  methods: {
    
    /** check page filter **/
    checkPageFilter(page){
      console.log(this.form.pages)
      if(this.form.pages.find(p => p.id == page.id))
        return false
      
      return page.name.toLowerCase().includes(this.pageFilter.toLowerCase()) || page.network.toLowerCase().includes(this.pageFilter.toLowerCase()) 
    
    },

    checkPagesInGroups(page) {
      return this.showAllPages ? false : this.groups.some(g => g.pages.includes(page.id))
    },

    changePosition(fromIndex, toIndex) {
      if(toIndex >= 0 && toIndex < this.form.pages.length){
        let element = this.form.pages[fromIndex];
        this.form.pages.splice(fromIndex, 1);
        this.form.pages.splice(toIndex, 0, element);
      }
    },

    selectAffected(page){
      this.selectedToAdd = []
      if(this.selectedToRemove.find(p => p.id == page.id))
        this.selectedToRemove = this.selectedToRemove.filter(p => p.id != page.id)
      else
        this.selectedToRemove.push(page)
    },
    
    selectAvailable(page){
      this.selectedToRemove = []
      if(this.selectedToAdd.find(p => p.id == page.id))
        this.selectedToAdd = this.selectedToAdd.filter(p => p.id != page.id)
      else
        this.selectedToAdd.push(page)
    },

    add() {
      if(this.selectedToAdd.length) {
        for(let page of this.selectedToAdd)
          this.form.pages.unshift(page)
        this.selectedToAdd = []
      }
    },

    remove() {
      if(this.selectedToRemove.length) {
        for(let page of this.selectedToRemove)
          this.form.pages = this.form.pages.filter(p => p.id != page.id)
        this.selectedToRemove = []
      }
    },

    raz() {
      this.form.pages = []
    },

    all() {
      this.form.pages = this.form.pages.concat(this.pages.filter(item => this.checkPageFilter(item)))
    },

    submit() {
      if(this.form.name && this.form.name != ''){
        let body = {}
        if(this.group && this.group.id) 
          body = this.group
        body.name = this.form.name
        body.pages = this.form.pages.map(p => p.id)
        
        if(this.group && this.group.id) 
          this.updateGroup(body)
          .then(res => {
            this.$emit('close')
          })
        else
          this.newGroup(body)
          .then(res => {
            this.$emit('close')
          })
      }
    },

    erase() {
      this.deleteGroup(this.group.id)
      .then(res => {
        this.$emit('close')
      })
    }
  }
}
</script>
